import { sessionDataType } from "../types/app.types.ts";

export const FetchAPIData = async (
  endpoint: string,
  { api: { apiKey: API_KEY, apiUrl: API_URL } }: sessionDataType,
  extraParams?: Record<string, string>,
) => {
  if (window.showSpinner) {
    window.showSpinner();
  }

  const params = new URLSearchParams({
    api_key: API_KEY,
    language: "en-US",
  });
  if (extraParams) {
    Object.entries(extraParams).forEach(([k, v]) => {
      if (v !== undefined && v !== "") {
        params.set(k, v);
      }
    });
  }

  const response = await fetch(`${API_URL}${endpoint}?${params.toString()}`);

  const data = await response.json();

  window.hideSpinner();

  return data;
};
